import React, {useState} from "react";
import "./HeaderStyles.scss";
import logo from "../images/logo_red.svg";
import {HamburgerMenu} from "../components/HamburgerMenu";
import {AboutPopup} from "../components/AboutPopup";
import {QuestionsPopup} from "../components/QuestionsPopup";
import {strings} from "../strings/strings";
import {ProductType} from "../api/model/common";

interface HeaderProps {
    homeUrl: string
    type: ProductType
}

export const Header = (props: HeaderProps) => {
    const {homeUrl, type} = props
    const [isHamburgerMenuOpen, setHamburgerMenuOpen] = useState(false);
    const [isAboutPopupOpen, setAboutPopupOpen] = useState(false);
    const [isQuestionsPopupOpen, setQuestionsPopupOpen] = useState(false);

    const toggleHamburgerMenu = () => {
        if (isHamburgerMenuOpen) {
            setAboutPopupOpen(false);
            setQuestionsPopupOpen(false);
        }

        setHamburgerMenuOpen(!isHamburgerMenuOpen);
    }

    const renderMenuItems = () => {
        return <>
            <div className={"menu-item"} onClick={() => setQuestionsPopupOpen(true)}>
                <span className={"item-title"}>{strings.menuQuestions}</span>
            </div>

            {isQuestionsPopupOpen &&
            <QuestionsPopup isOpen={isQuestionsPopupOpen} onClose={() => setQuestionsPopupOpen(false)} type={type}/>}

            <div className={"menu-item"} onClick={() => setAboutPopupOpen(true)}>
                <span className={"item-title"}>{strings.menuAbout}</span>
            </div>

            {isAboutPopupOpen && <AboutPopup isOpen={isAboutPopupOpen} onClose={() => setAboutPopupOpen(false)}/>}
        </>;
    }

    return (
        <div className={"header-wrapper"}>
            <div className={"header"}>
                <div className={"logo"}>
                    <a href={homeUrl}>
                        <img src={logo} alt={''}/>
                    </a>
                </div>

                <div className={"header-content"}>
                    <div className={"menu"}>
                        {renderMenuItems()}
                    </div>

                    <div className={"contacts"}>
                        <span className={"phone"}>{strings.phoneContact}</span>
                        <span className={"label"}>{strings.contacts}</span>
                    </div>

                    <HamburgerMenu onClick={toggleHamburgerMenu}/>
                </div>
            </div>

            <div className={`menu menu--mobile ${isHamburgerMenuOpen ? 'menu--open' : 'menu--closed'}`}>
                {renderMenuItems()}
            </div>
        </div>
    );
};